// extracted by mini-css-extract-plugin
export default {"container":"ChangePacks_container__E2Klb","icon":"ChangePacks_icon__OyBQX"};